<template>
    <section class="section section5">
      <div class="section-wrap">
        <img src="@/assets/images/home/map.png" v-if="$t('language.name') != 'English'">
        <img src="@/assets/images/home/map1.png" v-if="$t('language.name') == 'English'">
        <div class="s5-text">
          <h2 class="s5-title">{{$t('home.s5_1')}}</h2>
          <p class="s5-ps" v-html="$t('home.s5_2')"></p>
        </div>
      </div>
    </section>
</template>

<script>
  export default {
    name: 'homeSection5',
    data () {
      return {

      }
    },
    created () {
      this.getList()
    },
    methods: {
      getList() {


      }
    }
  }
</script>
<style lang="stylus" scoped>
  @import "~@/assets/css/public.styl"
  .section5
    rela();background-image url("~@/assets/images/home/5-bg.png");bgCover()
    img
      width: 100%
    .s5-text
      absoCenter();top .5rem
      .s5-title
        text-align center;font-size .36rem;color $standardColor
      .s5-ps
        text-align center;margin-top .05rem;font-size .14rem;color #666666
</style>
